import React, { useState, useEffect } from 'react';
import { AnalysisResult, Footer } from '../components';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  withCredentials: true
});

export function AnalysisPage() {
  const { analysisId } = useParams();
  const [url, setUrl] = useState('');

  useEffect(() => {
    const fetchAnalysis = async () => {
      try {
        const response = await api.get(`/api/analysis/${analysisId}`);
        setUrl(response.data.url);
      } catch (err) {
        console.error('Failed to fetch analysis:', err);
      }
    };

    fetchAnalysis();
  }, [analysisId]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <main className="container mx-auto px-4 pt-20 pb-32 md:pt-32">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white leading-tight tracking-tighter">
            Analysis Results
          </h1>
          <p className="text-xl md:text-2xl text-zinc-400 mb-12">
            Here's what our AI agents found on{' '}
            <a href={url} target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-400">
              {url}
            </a>
          </p>
        </div>
        <div className="max-w-5xl mx-auto">
          <AnalysisResult />
        </div>
      </main>
      <Footer />
    </div>
  );
} 